import React from 'react';
import { isSafari } from 'react-device-detect';
import PortraitPaperLayout from '../@common/portrait/PortraitPaperLayout';
import GridWithText from '../@common/GridWithText';
import { WorksheetBaseProps } from '../@types';
import { translate } from '../../translations/translator';

const t = key => translate('worksheet', key);

type NameLabelsProps = WorksheetBaseProps & {
  value: string;
  isCursive?: boolean;
  isNarrow?: boolean;
  isWide?: boolean;
};

const NameLabels = ({
  onChange,
  isCursive,
  isNarrow,
  valueMap,
  isWide,
  printRef
}: NameLabelsProps) => {
  const handleChange = (key, value) => {
    onChange({
      [key]: value
    });
  };

  return (
    <PortraitPaperLayout isNarrow={isNarrow} isWide={isWide} addAveryText printRef={printRef}>
      <GridWithText
        width={675}
        height={135}
        numOfCols={1}
        numOfRows={5}
        handleChange={handleChange}
        valueMap={valueMap}
        spaceBtwnCols={0}
        textLinePaddingTop={60}
        isCursive={isCursive}
        isNarrow={isNarrow}
        isWide={isWide}
        placeholder={t('name')}
        cardMarginTop={isSafari ? 55 : 65}
      />
    </PortraitPaperLayout>
  );
};

export default NameLabels;
